// extracted by mini-css-extract-plugin
export default {"container":"PricesApplied_container__v-BBG","text":"PricesApplied_text__zQ9RQ","icon":"PricesApplied_icon__OI14t"};